export default "__VITE_ASSET__32e8ef57__"